<template>
  <div class="modal print_modal" :class="{ open_modal: openQuestionModal }">
    <div class="modal_overlay"></div>
    <div class="modal_inner max_height_80">
      <div class="modal_header">
        <h2>{{ $t('sidebar.questions.questions') }}</h2>
        <span class="close_icon close_icon_sm" @click="closeModal()">×</span>
      </div>
      <div class="modal_wrapper">
        <div class="modal_content modal_1400p">
          <div class="row mt_10">
            <div class="col_2">
              <div class="form-group">
                <div class="d_flex_start">
                  <div class="dropdown custom_dropdown mr_10">
                    <button class="btn">
                      <span>
                        {{
                          filter.subject != '' && subjects.length
                            ? subjects.find(
                                (s) => s.id === parseInt(filter.subject)
                              ).name
                            : $t('common.subject')
                        }}</span
                      >
                    </button>
                    <div class="dropdown_menu">
                      <ul>
                        <li
                          @click="subjectFilter(subject.id)"
                          v-for="subject in subjects"
                          :key="'subject' + subject.id"
                        >
                          <a role="button">{{ subject.name }}</a>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="col_2">
              <div class="form-group">
                <div class="d_flex_start">
                  <div class="dropdown custom_dropdown mr_10">
                    <button class="btn">
                      <span>
                        {{
                          filter.question_type != '' && question_types.length
                            ? question_types.find(
                                (s) => s.id === parseInt(filter.question_type)
                              ).name
                            : $t('common.question_type')
                        }}</span
                      >
                    </button>
                    <div class="dropdown_menu">
                      <ul>
                        <li
                          @click="questionTypeFilter(question_type.id)"
                          v-for="question_type in question_types"
                          :key="'question_type' + question_type.id"
                        >
                          <a role="button">{{ question_type.name }}</a>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="col_2">
              <div class="form-group">
                <div class="d_flex_start">
                  <div class="dropdown custom_dropdown mr_10">
                    <button class="btn">
                      <span>
                        {{
                          filter.folder_grade != '' && folder_grades.length
                            ? folder_grades.find(
                                (s) => s.id === parseInt(filter.folder_grade)
                              ).name
                            : $t('common.folder_grade')
                        }}</span
                      >
                    </button>
                    <div class="dropdown_menu">
                      <ul>
                        <li
                          @click="folderGradeFilter(folder_grade.id)"
                          v-for="folder_grade in folder_grades"
                          :key="'folder_grade' + folder_grade.id"
                        >
                          <a role="button">{{ folder_grade.name }}</a>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="col_2">
              <div class="form-group">
                <div class="d_flex_start">
                  <div class="dropdown custom_dropdown mr_10">
                    <button class="btn">
                      <span>
                        {{
                          filter.folder_semester != '' &&
                          folder_semesters.length
                            ? folder_semesters.find(
                                (s) => s.id === parseInt(filter.folder_semester)
                              ).name
                            : $t('common.folder_semester')
                        }}</span
                      >
                    </button>
                    <div class="dropdown_menu">
                      <ul>
                        <li
                          @click="folderSemesterFilter(folder_semester.id)"
                          v-for="folder_semester in folder_semesters"
                          :key="'folder_semester' + folder_semester.id"
                        >
                          <a role="button">{{ folder_semester.name }}</a>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="col_3">
              <div class="form-group">
                <Multiselect
                  v-model="filter.folder_unit"
                  :placeholder="$t('common.select_folder_unit')"
                  :caret="false"
                  :close-on-select="false"
                  :searchable="true"
                  :create-option="true"
                  :hideSelected="false"
                  :options="folder_units"
                  @select="folderUnitFilter()"
                />
              </div>
              <!-- <div class="form-group ">
                            <div class="d_flex_start">
                                <div class="dropdown custom_dropdown mr_10">
                                    <button class="btn">
                                        <span> {{ filter.folder_unit != '' && folder_units.length ? folder_units.find(s=> s.id === parseInt(filter.folder_unit)).name : $t('common.folder_unit') }}</span>
                                    </button>
                                    <div class="dropdown_menu">
                                        <ul>
                                            <li @click="folderUnitFilter(folder_unit.id)" v-for="folder_unit in folder_units" :key="'folder_unit'+folder_unit.id"><a role="button">{{ folder_unit.name }}</a></li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div> -->
            </div>
            <div class="col_1">
              <div class="form-group">
                <div class="d_flex_start">
                  <div class="dropdown custom_dropdown mr_10">
                    <button class="btn">
                      <span>
                        {{
                          filter.difficulty != '' && difficulties.length
                            ? difficulties.find(
                                (s) => s.id === parseInt(filter.difficulty)
                              ).name
                            : $t('sidebar.difficulty.difficulty')
                        }}</span
                      >
                    </button>
                    <div class="dropdown_menu">
                      <ul>
                        <li
                          @click="difficultyFilter(difficulty.id)"
                          v-for="difficulty in difficulties"
                          :key="'difficulty' + difficulty.id"
                        >
                          <a role="button">{{ difficulty.name }}</a>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="row mt_10">
            <div class="col_2">
              <div class="form-group">
                <div class="d_flex_start">
                  <div class="dropdown custom_dropdown mr_10">
                    <button class="btn">
                      <span>
                        {{
                          filter.semester != '' && semesters.length
                            ? semesters.find(
                                (s) => s.id === parseInt(filter.semester)
                              ).name
                            : $t('common.semester')
                        }}</span
                      >
                    </button>
                    <div class="dropdown_menu">
                      <ul>
                        <li
                          @click="semesterFilter(semester.id)"
                          v-for="semester in semesters"
                          :key="'semester' + semester.id"
                        >
                          <a role="button">{{ semester.name }}</a>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="col_2">
              <div class="form-group">
                <div class="d_flex_start">
                  <div class="dropdown custom_dropdown mr_10">
                    <button class="btn">
                      <span>
                        {{
                          filter.grade != '' && grades.length
                            ? grades.find(
                                (s) => s.id === parseInt(filter.grade)
                              ).name
                            : $t('common.grade')
                        }}</span
                      >
                    </button>
                    <div class="dropdown_menu">
                      <ul>
                        <li
                          @click="gradeFilter(grade.id)"
                          v-for="grade in grades"
                          :key="'grade' + grade.id"
                        >
                          <a role="button">{{ grade.name }}</a>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="col_2">
              <div class="drop-down">
                <div class="selected">
                  <span>{{
                    filter.unit != '' && units.length
                      ? units.find((s) => s.id == parseInt(filter.unit))
                          .unit_name
                      : $t('common.unit')
                  }}</span>
                </div>
                <div class="options">
                  <ul style="display: none">
                    <li
                      @click="unitFilter(unit.id)"
                      v-for="unit in units"
                      :key="'unit' + unit.id"
                    >
                      {{ unit.unit_name
                      }}<span class="value">{{ unit.id }}</span>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
            <div class="col_2">
              <div class="form-group">
                <div class="d_flex_start">
                  <div class="dropdown custom_dropdown mr_10">
                    <button class="btn">
                      <span>
                        {{
                          filter.assign != '' && assigns.length
                            ? assigns.find(
                                (s) => s.id === parseInt(filter.assign)
                              ).assign_name
                            : $t('common.assign')
                        }}</span
                      >
                    </button>
                    <div class="dropdown_menu">
                      <ul>
                        <li
                          @click="assignFilter(assign.id)"
                          v-for="assign in assigns"
                          :key="'assign' + assign.id"
                        >
                          <a role="button">{{ assign.assign_name }}</a>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="col_4">
              <div class="form-group">
                <div class="d_flex_end">
                  <div class="form_row_inline">
                    <input
                      type="text"
                      class="form_global"
                      :placeholder="$t('common.search')"
                      v-model="queryParams.search"
                    />
                  </div>
                  <div class="form_row_inline ml_10">
                    <div
                      class="btn btn_common_type_2 mr_10 width_150p"
                      @click="
                        queryParams.page = 1;
                        searchQuery();
                      "
                    >
                      {{ $t('common.search') }}
                    </div>
                    <div
                      class="btn btn_secondary width_150p"
                      @click="resetAll()"
                    >
                      {{ $t('common.reset') }}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="table_responsive">
              <table class="table">
                <thead>
                  <tr>
                    <!--                                    <th>{{ $t('common.select') }}</th>-->
                    <th>
                      <div class="form-group mb_0">
                        <label style="min-height: 0px"></label>
                        <div class="form_checkbox">
                          <input
                            type="checkbox"
                            id="selectAll"
                            v-model="selectAll"
                          />
                          <label for="selectAll"></label>
                        </div>
                      </div>
                    </th>
                    <th class="width_200p">{{ $t('common.title') }}</th>
                    <th class="width_200p">{{ $t('sidebar.exams.type') }}</th>
                    <th class="width_200p">
                      {{ $t('sidebar.difficulty.difficulty') }}
                    </th>
                    <th class="width_200p">{{ $t('sidebar.point.point') }}</th>
                    <th class="width_200p">
                      {{ $t('sidebar.questions.admin_note') }}
                    </th>
                    <th class="width_200p">
                      {{ $t('sidebar.questions.assigned_in') }}
                    </th>
                    <th>{{ $t('common.action') }}</th>
                  </tr>
                </thead>
                <tbody v-if="questions.length">
                  <tr
                    v-for="(question, index) in questions"
                    :key="'question_' + index"
                  >
                    <td class="width_50p">
                      <div class="form-group mb_0">
                        <label style="min-height: 0px"></label>
                        <div class="form_checkbox">
                          <input
                            type="checkbox"
                            :id="'new_id_' + question.id"
                            :value="question.id"
                            v-model="ids"
                          />
                          <label :for="'new_id_' + question.id"></label>
                        </div>
                      </div>
                    </td>
                    <td class="overflow_hidden question_title width_200p">
                      <router-link
                        :to="{
                          name: 'exam_questions_edit',
                          params: { id: question.id },
                        }"
                        target="_blank"
                      >
                        <div
                          class="text_shorten"
                          v-html="convertTextEditor(question.title)"
                        ></div>
                      </router-link>
                    </td>
                    <td class="width_200p">
                      {{
                        question.question_type === 'multiple-choice'
                          ? $t('sidebar.questions.multiple_choice')
                          : question.question_type === 'short-answer'
                          ? $t('sidebar.questions.short_answer')
                          : $t('sidebar.questions.descriptive')
                      }}
                    </td>
                    <td class="width_200p">
                      {{ question.difficulty ? question.difficulty.name : '' }}
                    </td>
                    <td class="width_200p">
                      {{ question.point ? question.point.point : '' }}
                    </td>
                    <td class="width_200p">
                      <div v-html="noteValue(question.admin_note, 20)"></div>
                    </td>
                    <td class="width_200p">
                      <template v-if="question?.assign?.exam?.title"
                        >{{ question?.assign?.exam?.title }},</template
                      >
                      {{ question?.subject?.name }},
                      {{ question?.grade?.name }},
                      {{ question?.semester?.name }},
                      {{ question?.unit?.unit_name }}
                    </td>
                    <td class="width_50p">
                      <a
                        role="button"
                        class="color_success cursor_pointer"
                        @click="selectQuestion(question.id)"
                        >{{
                          ids.includes(question.id)
                            ? $t('common.unselect')
                            : $t('common.select')
                        }}</a
                      >
                    </td>
                  </tr>
                </tbody>
                <tbody v-else>
                  <tr>
                    <td colspan="8">{{ $t('common.no_data_msg') }}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
          <div class="row">
            <div class="col_12">
              <pagination-component
                :pagination="pagination"
                @changePage="pageChanged"
              ></pagination-component>
            </div>
          </div>
          <div class="common_content">
            <div class="common_content_btn d_flex_end">
              <button class="btn btn_blue ml_5" @click="selectedQuestion()">
                {{ $t('common.select') }}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import PaginationComponent from '@/components/shared/PaginationComponent';
import Mathml2latex from 'mathml-to-latex';
import Multiselect from '@vueform/multiselect';
export default {
  name: 'QuestionModal',
  components: {
    PaginationComponent,
    Multiselect,
  },
  props: {
    openQuestionModal: {
      type: Boolean,
      required: true,
    },
    selectedQuestions: {
      type: Array,
      required: false,
    },
    unit_id: {
      type: String,
      required: false,
    },
    grade_id: {
      type: String,
      required: false,
    },
    semester_id: {
      type: String,
      required: false,
    },
  },
  data() {
    return {
      subjects: [],
      question_types: [],
      folder_grades: [],
      folder_semesters: [],
      folder_units: [],
      difficulties: [],
      semesters: [],
      grades: [],
      units: [],
      assigns: [
        {
          id: 1,
          assign_name: this.$t('common.assigned'),
        },
        {
          id: 2,
          assign_name: this.$t('common.not_assigned'),
        },
      ],
      filter: {
        difficulty: '',
        subject: '',
        grade: this.grade_id,
        semester: this.semester_id,
        unit: this.unit_id,
        question_type: '',
        folder_grade: '',
        folder_semester: '',
        folder_unit: '',
        assign: '',
      },
      queryParams: {
        page: 1,
        per_page: 10,
        search: '',
        search_columns: 'title',
        grade: null,
      },
      ids: [],
      questions: [],
      pagination: null,
    };
  },
  watch: {
    openModal: {
      deep: true,
      handler(value) {
        if (value) this.loadData();
      },
    },
  },
  computed: {
    selectAll: {
      get: function () {
        return this.questions
          ? this.ids.length === this.questions.length
          : false;
      },
      set: function (value) {
        var selected = [];

        if (value) {
          this.questions.forEach(function (question) {
            selected.push(question.id);
          });
        }

        this.ids = selected;
      },
    },
  },
  updated() {
    this.$nextTick().then(() => {
      if (window.MathJax) {
        window.MathJax.Hub.Queue(['Typeset', window.MathJax.Hub]);
      }
    });
  },
  created() {
    this.$nextTick().then(() => {
      if (window.MathJax) {
        window.MathJax.Hub.Queue(['Typeset', window.MathJax.Hub]);
      }
    });
    this.loadData();
    this.axios
      .get('/difficulties')
      .then((response) => (this.difficulties = response.data.data));
    this.axios
      .get('/subjects')
      .then((response) => (this.subjects = response.data.data));
    this.axios
      .get('/semesters')
      .then((response) => (this.semesters = response.data.data));
    this.axios
      .get('/grades')
      .then((response) => (this.grades = response.data.data));
    this.axios
      .get('/units')
      .then((response) => (this.units = response.data.data));

    this.axios
      .get('/question_types')
      .then((response) => (this.question_types = response.data.data));
    this.axios
      .get('/folder_grades')
      .then((response) => (this.folder_grades = response.data.data));
    this.axios
      .get('/folder_semesters')
      .then((response) => (this.folder_semesters = response.data.data));
    // this.axios.get('/folder_units').then((response) => this.folder_units = response.data.data);

    this.axios.get('/folder_units').then((response) => {
      response.data.data.forEach((element) => {
        let unit = {
          value: element.id,
          label: element.name,
        };
        this.folder_units.push(unit);
      });
    });

    this.ids = this.selectedQuestions;
  },
  methods: {
    selectAllRecord(val) {
      const selected = [];

      if (val) {
        this.questions.forEach(function (question) {
          selected.push(question.id);
        });
        this.checkedQuestion = selected;
      } else {
        this.checkedQuestion = [];
      }
    },
    __convertTextEditor(string) {
      return string ? string.replace(/<img[^>]*>/g, '') : '';
    },
    convertTextEditor(string) {
      let parser = new DOMParser();
      const doc = parser.parseFromString(string, 'text/html');
      let mathTags = doc.getElementsByTagName('math');
      if (mathTags.length > 0) {
        [...mathTags].forEach((mathTag) => {
          mathTag.replaceWith(this.getLatex(mathTag.outerHTML));
        });
        return doc.body.innerHTML.replace(/<img[^>]*>/g, '');
      } else {
        return string ? string.replace(/<img[^>]*>/g, '') : '';
      }
    },
    getLatex(mathTag) {
      try {
        let latex = Mathml2latex.convert(mathTag);
        latex = this.sanitizeLatex(latex);
        latex = `\\[${latex}\\]`; // for block math
        return latex;
      } catch (error) {
        console.error('Latex conversion failed:', error);
        return mathTag; // fallback: keep original MathML
      }
    },
    sanitizeLatex(latex) {
      return latex
        .replace(/&nbsp;/g, ' ') // remove non-breaking spaces
        .replace(/\\left\\\(\\right\.\s*/g, '\\left(') // fix left paren
        .replace(/\s*\\left\.\s*\\right\\\)/g, '\\right)') // fix right paren
        .replace(/\s{2,}/g, ' ') // remove extra spaces
        .trim();
    },
    __getLatex(mathTag) {
      let latex = Mathml2latex.convert(mathTag);
      latex = '$$' + latex + '$$';
      latex = latex.replace(/\+\b/g, '\\\\');
      return latex;
    },
    noteValue(value, length) {
      let parser = new DOMParser();
      let doccument = parser.parseFromString(value, 'text/html');
      let finalNote =
        doccument.getElementsByTagName('p').length > 0
          ? doccument.getElementsByTagName('p')[0].textContent
          : '';

      if (finalNote.length > length) {
        return finalNote.substring(0, length) + '...';
      } else {
        return finalNote;
      }
    },
    loadData() {
      this.axios
        .get('/questions', {
          params: {
            ...this.queryParams,
            ...this.filter,
          },
        })
        .then((response) => {
          this.questions = response.data.data;
          this.pagination = response.data.meta;
        });
    },
    selectQuestion(id) {
      if (this.ids.includes(id)) {
        var index = this.ids.indexOf(id);
        if (index !== -1) {
          this.ids.splice(index, 1);
        }
      } else {
        this.ids.push(id);
      }
    },
    resetAll() {
      this.filter = {
        difficulty: '',
        subject: '',
        semester: '',
        grade: '',
        unit: '',
        question_type: '',
        folder_grade: '',
        folder_semester: '',
        assign: '',
        folder_unit: '',
      };

      this.queryParams = {
        page: 1,
        per_page: 10,
        search: '',
        search_columns: 'title',
        grade: null,
      };

      this.loadData();
    },
    difficultyFilter(id) {
      this.filter.difficulty = id;
      this.loadData();
    },
    subjectFilter(id) {
      this.filter.subject = id;
      this.loadData();
    },
    semesterFilter(id) {
      this.filter.semester = id;
      this.loadData();
    },
    gradeFilter(id) {
      this.filter.grade = id;
      this.loadData();
    },
    unitFilter(id) {
      this.filter.unit = id;
      this.loadData();
    },
    questionTypeFilter(id) {
      this.filter.question_type = id;
      this.loadData();
    },
    folderGradeFilter(id) {
      this.filter.folder_grade = id;
      this.loadData();
    },
    folderSemesterFilter(id) {
      this.filter.folder_semester = id;
      this.loadData();
    },
    folderUnitFilter() {
      // this.filter.folder_unit = id
      this.loadData();
    },
    assignFilter(id) {
      this.filter.assign = id;
      this.loadData();
    },
    searchQuery() {
      this.loadData();
    },
    pageChanged(page) {
      this.queryParams.page = page;
      this.loadData();
    },
    closeModal() {
      this.$emit('closeQuestionModal');
    },
    selectedQuestion() {
      this.axios
        .get('/selected-questions', {
          params: { ids: this.ids },
        })
        .then((response) => {
          this.$emit('questionData', response.data.data);
          this.ids = [];
          this.closeModal();
        });
      // let questionData = this.questions.filter((question) => this.ids.includes(question.id))
      // this.$emit('questionData', questionData)
      // this.ids = []
      // this.closeModal();
    },
  },
};
</script>

<style scoped>
.modal_header h2 {
  text-align: center;
  padding: 20px 0px;
}

.search_btn {
  padding: 10px 10px 10px 15px;
  margin: 0px 10px 0px 0px;
}

.reset_btn {
  padding: 10px 10px 10px 15px;
}

.table tr td:nth-of-type(2) {
  text-align: center !important;
  /* padding: 10px 0px 10px 231px; */
}
</style>
<style src="@vueform/multiselect/themes/default.css"></style>
